import { Navigate, createBrowserRouter } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Entry from '../pages/Entry';
import Admin from '../pages/Admin';
import Guide from '../pages/Guide';
import Gallery from '../pages/Gallery';
import CyberpunkGallery from '../pages/CyberpunkGallery';
import Outro from '../pages/Outro';
import NotFound from '../pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '/', element: <Entry /> },
      { path: '/archive/*', element: <Gallery /> },
      { path: '/cyberpunk', element: <CyberpunkGallery /> },
      { path: '/outro', element: <Outro /> },
      // MCP 接入指南按工具集分层路由，可直接定位：/guide/doc | /guide/photo
      { path: '/guide', element: <Navigate to="/guide/doc" replace /> },
      { path: '/guide/:target', element: <Guide /> },
      { path: '/admin', element: <Admin /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
